"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeRequestGeneral = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const translation_1 = require("../../../common/js/helper/translation");
const ChangeRequestLengths_1 = require("../../constants/ChangeRequestLengths");
exports.ChangeRequestGeneral = (0, mobx_react_1.observer)(class ChangeRequestGeneral extends react_1.default.Component {
    currentData = {};
    componentDidMount() {
        this.currentData = this.props.data ?? {};
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: "znd-change-request-modal__input-header t-body-small" },
                (0, translation_1.t)('change_request_modal.body.comment.label'),
                " ",
                react_1.default.createElement("span", { className: "required" }, "*")),
            react_1.default.createElement("textarea", { className: "form-control", key: "comment", value: this.props.data?.comment, onChange: (event) => {
                    this.currentData.comment = event.target.value;
                    this.props.onChangeData(this.currentData);
                }, placeholder: (0, translation_1.t)('change_request_modal.body.comment.placeholder'), required: true, disabled: this.props.disabled, rows: ChangeRequestLengths_1.ChangeRequestLengths.TEXTAREA_ROWS, maxLength: ChangeRequestLengths_1.ChangeRequestLengths.TEXTAREA_MAX_LENGTH })));
    }
});
